<template>
  <b2b-overlay v-model="isActive" role="dialog" full-screen>
    <b2b-card width="100vw" height="100vh" fill-height>
      <b2b-input-search v-model="query.search" clearable flat>
        <template #expand>
          <b2b-input-letter v-model="query.startLetter" :items="letters" />
        </template>
      </b2b-input-search>

      <b2b-card-text scrollable>
        <h3 class="mt--3 mx--3" v-text="title" />

        <b2b-grid>
          <b2b-grid-row wrap>
            <template v-for="tag in tags">
              <b2b-grid-column cols="12" tablet="6" :key="tag.id">
                <b2b-checkbox
                  v-model="$_model"
                  :value="tag.id"
                  :label="tag.descricao"
                  @change="$_onChange($event, tag)" />
              </b2b-grid-column>
            </template>
          </b2b-grid-row>
        </b2b-grid>
      </b2b-card-text>

      <b2b-card-actions>
        <b2b-pagination v-model="query.page" :pages="pages" small />

        <b2b-spacer />

        <b2b-button @click.stop="$_onClickOk" v-text="$t('labels.ok')" dense />
      </b2b-card-actions>
    </b2b-card>
  </b2b-overlay>
</template>

<script>
import ActivableMixin from '../../mixins/base/activable-mixin';
import ModelMixin from '../../mixins/base/model-mixin';
import ActionResolver from '../../mixins/action-resolver';

import B2bOverlay from '../core/b2b-overlay.vue';
import B2bCard from '../core/card/b2b-card.vue';
import B2bCardText from '../core/card/b2b-card-text.vue';
import B2bCardActions from '../core/card/b2b-card-actions.vue';
import B2bInputSearch from '../core/form/b2b-input-search.vue';
import B2bInputLetter from '../core/form/b2b-input-letter.vue';
import B2bGrid from '../core/grid/b2b-grid.vue';
import B2bGridRow from '../core/grid/b2b-grid-row.vue';
import B2bGridColumn from '../core/grid/b2b-grid-column.vue';
import B2bCheckbox from '../core/form/b2b-checkbox.vue';
import B2bPagination from '../core/b2b-pagination.vue';
import B2bSpacer from '../core/b2b-spacer.vue';
import B2bButton from '../core/buttons/b2b-button.vue';

export default {
  name: 'b2b-dialog-tags',

  components: {
    B2bOverlay,
    B2bCard,
    B2bCardText,
    B2bCardActions,
    B2bInputSearch,
    B2bInputLetter,
    B2bGrid,
    B2bGridRow,
    B2bGridColumn,
    B2bCheckbox,
    B2bPagination,
    B2bSpacer,
    B2bButton,
  },

  mixins: [
    ActivableMixin('active'),

    ModelMixin(Array),

    ActionResolver(),
  ],

  props: {
    title: String,
    tagTypeId: [String, Number],
  },

  data() {
    return {
      tags: [],
      letters: [],
      pages: 1,
      query: {
        page: 1,
        search: null,
        startLetter: null,
      },
    };
  },

  methods: {
    $_load() {
      if (this.ignoreNextLoad) {
        this.ignoreNextLoad = false;
        return;
      }

      this.$_actionResolver({
        action: 'tags/letters',
        params: {
          tipoAgrupamentoId: this.tagTypeId,
        },
      })
        .then(({ items }) => {
          this.letters = items;
        });

      this.$_actionResolver({
        action: 'tags/index',
        params: {
          page: this.query.page,
          s: this.query.search,
          ss: this.query.startLetter,
          'agrupamentos.tipoAgrupamentoId': this.tagTypeId,
        },
      })
        .then(({ items, pages }) => {
          this.tags = items;
          this.pages = pages;
        });
    },

    $_reload() {
      this.pages = 1;

      if (this.query.page !== 1) {
        this.query.page = 1;
        this.ignoreNextLoad = true;
      }

      if (this.query.search !== null) {
        this.query.search = null;
        this.ignoreNextLoad = true;
      }

      if (this.query.startLetter !== null) {
        this.query.startLetter = null;
        this.ignoreNextLoad = true;
      }

      this.$nextTick(() => {
        this.$_load();
      });
    },

    $_onClickOk() {
      this.isActive = false;
    },

    $_onChange($event, $tag) {
      this.$emit('change', { $event, $tag });
    },
  },

  watch: {
    isActive(active) {
      if (active) this.$_reload();
    },

    'query.page': function onWatchQueryPage() {
      this.$_load();
    },

    'query.search': function onWatchQuerySearch() {
      if (this.query.page !== 1) {
        this.query.page = 1;
      } else {
        this.$_load();
      }
    },

    'query.startLetter': function onWatchQueryStartLetter() {
      if (this.query.page !== 1) {
        this.query.page = 1;
      } else {
        this.$_load();
      }
    },
  },
};
</script>
